<template>
<!--    hemen buraya isloading-->
    <div v-if="!isLoading" class="overview">
<!--            <div class="tabs">-->
<!--                <ul>-->
<!--                    <li class="is-active"><a>6EED42E1-21B8-46C2-BA69-F2F50656AFA4 (SAY)</a></li>-->
<!--                    <li><a>E685CF36-6393-4174-BFF7-38A0FEB5F8FF	(GDE)</a></li>-->
<!--                </ul>-->
<!--            </div>-->

            <div class="tabs">
                <ul v-for="(item,index) in TLCVersionsTabSectionCalculate" :key="index">
                    <!-- v-if="item.devicE_UUID == ActiveDevice_UID" -->
                    <li @click="GetIpadPreviewAlldataRelatedUID(item)" :style="item.devicE_UUID == ActiveDevice_UID ? 'color=red;': 'color=black;'"> <a >{{item.devicE_UUID}}</a> </li>
                </ul>
            </div>

            <div class="columns">
                <div class="column is-two-fifths">
                    <div class="title is-size-5 ">Over View</div>

<!--                    // Buraya tab section koyabiliriz.     TLCVersionsTabSectionCalculate bu liste üzerinde ....-->

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Flight</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input v-if="flight.carrier&&flight.fno" type="text" class="input"  :value="flight.carrier + flight.fno" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Call Sign</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input v-if="flight.callsign" type="text" class="input"  :value="flight.callsign" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Date</label></div>
                        <div class="field-body">
                            <div class="field">
                                <div class="field">
                                    <div class="control">
                                        <input type="text" class="input" v-model="getDatevalue" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">STD</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="datetime-local" class="input" v-model="flight.std" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">STA</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="datetime-local" class="input" v-model="flight.sta" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Origin</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="text" class="input" v-model="flight.adep" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Destination</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="text" class="input" v-model="flight.aarr" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Registration</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="text" class="input" v-model="flight.acreg" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column is-two-fifths">
                    <div class="title is-size-5"><p>Cabin</p></div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">PIC</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="text" class="input" v-model="flight.cP1" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">F/O</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="text" class="input" v-model="flight.cP2" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Additional Crew</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">

                                        <div v-if="flight.cabinList"> <input type="text" class="input" v-model="flight.cabinList" readonly> </div>
                                        <div v-else-if="additionalCrew !=' '"> <input type="text" class="input" v-model="additionalCrew" readonly> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div v-if="addtest2"><input type="text" class="input" v-model="addtest2" readonly></div> -->

                    <div class="field is-horizontal">
                        <div class="field-label"><label class="label">Last Update</label></div>
                        <div class="field-body">
                            <div class="field ">
                                <div class="field ">
                                    <div class="control">
                                        <input type="datetime-local" class="input" v-model="flight.modifydate" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        <br/>


        <table class="table is-hoverable is-narrow is-striped">
            <thead>
                <tr>
                    <th class="VersHead" colspan="3">IPAD Device</th>
                    <th class="VersHead" colspan="2">Netline</th>
                    <th class="VersHead" colspan="2">Jeppesen</th>
                    <th class="VersHead" colspan="2">Jetplan</th>
                    <th class="VersHead" colspan="2">Attachments</th>
                </tr>
                <tr>
                    <th>IDREC</th>
                    <th>UUID</th>
                    <th>TLC</th>

                    <th class="LeftBorderLine">OCC</th>
                    <th class="RightBorderLine">IPAD</th>

                    <th class="LeftBorderLine">OCC</th>
                    <th class="RightBorderLine">IPAD</th>

                    <th class="LeftBorderLine">OCC</th>
                    <th class="RightBorderLine">IPAD</th>

                    <th class="LeftBorderLine">OCC</th>
                    <th class="RightBorderLine">IPAD</th>
                </tr>
            </thead>

            <tbody v-if="this.OccIpadVersions && this.OccIpadVersions.length">
            <tr v-for="(version,index) in OccIpadVersions" :key="index">

                <td><b>{{version.idreC_IPAD_DEVICE}}</b></td>
                <td><b>{{version.devicE_UUID}}</b></td>
                <td><b>{{version.tlc}}</b></td>

                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(1,2)]}" class="LeftBorderLine" >{{version.nlvt}} <br/><p class="RowinP">{{version.nlvT_DT}}</p></td>
                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(1,2)]}" class="RightBorderLine">{{version.nlvc}} <br/><p class="RowinP">{{version.nlvC_DT}}</p></td>

                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(3,4)]}" class="LeftBorderLine">{{version.jlvt}} <br/><p class="RowinP">{{version.jlvT_DT}}</p></td>
                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(3,4)]}" class="RightBorderLine">{{version.jlvc}} <br/><p class="RowinP">{{version.jlvC_DT}}</p></td>

                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(5,6)]}" class="LeftBorderLine">{{version.wlvt}} <br/><p class="RowinP">{{version.wlvT_DT}}</p></td>
                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(5,6)]}" class="RightBorderLine">{{version.wlvc}} <br/><p class="RowinP">{{version.wlvC_DT}}</p></td>

                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(7,8)]}" class="LeftBorderLine">{{version.alvt}} <br/><p class="RowinP">{{version.alvT_DT}}</p></td>
                <td :style="{backgroundColor : StatuColorArray[version.stattext.substring(7,8)]}" class="RightBorderLine">{{version.alvc}} <br/><p class="RowinP">{{version.alvC_DT}}</p></td>

            </tr>
            </tbody>
            <div v-else>
                <p>Not found Details of OCCSelfVersions_VS_IPADLastKnownVersions. </p>
            </div>

        </table>


    </div>
    <div v-else>
        <loading-button/>
    </div>


</template>

<script>

    import {loadingMixin} from "../../../utils/mixins";
    import {mapActions, mapState} from "vuex";
    import LoadingButton from "../../../components/ui/LoadingButton";

    export default {
        name: "OverView",
        mixins: [loadingMixin],
        props: ["id", "flight", "additionalCrew"],

        data() {
            return {
                saveButtonActive: false,
                StatuColorArray :[
                    "#f14668",
                    "#48c774",
                    "#FDA50F",
                    "#FDA50F",
                    "#FDA50F",
                    "#FDA50F",
                ],
            }
        },

        async created()
        {

        },

        components:
        {
            LoadingButton,

        },

        methods: {

            ...mapActions("ipadmain", ["GetNotamImportantWList","ClearInputsObject",
                                        "ActiveDevice_UID","GetLastJrJson",
                                        "GetLastWrJson", "GetLastAttachmentJson",
                                        "GetLastOCCSelfVersions_VS_IPADLastKnownVersions",
                                        "GetLastInputsJson","SetinputsToObject",
                                        "GetLastFilesJson","GetCombinedAllJson"]),

            async GetIpadPreviewAlldataRelatedUID(item)
            {

                // buradaki senaryoyu yeninden düzenle -->
                //
                var val = item;
                console.log(val);
                //ipadmain state de activeDevice uid set edilecek....
                this.ClearInputsObject();
                this.ActiveDevice_UID = item.devicE_UUID;

                try
                {
                    this.GetNotamImportantWList(); //await koyulabilir gerekirse
                }
                catch (e)
                {
                    this.$notify({title: "Warning", text:"Couldn't get Notam Important Word List from server."+e.message, type: "warning"});
                }

                try
                {
                    this.GetLastAttachmentJson({LastKeyForNetline:this.selectedFlight.fKeyForNetline, STD:this.selectedFlight.std}); //await
                }
                catch (e)
                {
                    this.$notify({title: "Warning", text:"Couldn't get attachments depending on the relevant flight. "+e.message, type: "warning"});
                }

                try {
                    await this.GetLastOCCSelfVersions_VS_IPADLastKnownVersions({KFZ:this.selectedFlight.fKeyForZip}); //await
                }
                catch (e) {
                    this.$notify({title: "Warning", text:"Couldn't Get Last OCC Self Versions VS IPAD Last Known Versions depending on the relevant flight. "+e.message, type: "warning"});
                }

                try
                {
                    await this.GetCombinedAllJson({KFZ:this.selectedFlight.fKeyForZip,STD:this.selectedFlight.std, JLVT:item.jlvt, WLVT:item.wlvt, DeviceUID:this.ActiveDevice_UID});
                }
                catch (e)
                {
                    this.$notify({title: "Warning", text:" Some json data of this flight couldn't get you can check data transfer status section "+e.message, type: "warning"});
                }

                var parsedObject = this.inputsToObject(this.RawInputs);

                await this.SetinputsToObject({data:parsedObject});
                //await this.GetLastFilesJson({KFZ:this.selectedFlight.fKeyForZip, STD:this.selectedFlight.std});
                this.additionalCrew = (this.InputsObject.BTO.additionalCrew === undefined || this.InputsObject.BTO.additionalCrew === null) ? " " : this.InputsObject.BTO.additionalCrew;
            }
        },

        computed: {

            ...mapState("ipadmain",["selectedFlightItems","EFF_Json_Data","WR_Json_Data","OCCSelfVersions_VS_IPADLastKnownVersions","InputsObject","CombinedJson"]),

            OccIpadVersions: function()
            {
                return this.OCCSelfVersions_VS_IPADLastKnownVersions;
            },

            TLCVersionsTabSectionCalculate: function()
            {

                let ListOccSelfVersionsCalulated=[];
                for(let i = 0;i<this.OCCSelfVersions_VS_IPADLastKnownVersions.length;i++)
                {
                        // DeviceUID isimlendirmesinde hata olabilir kontrol et.
                        if(this.OCCSelfVersions_VS_IPADLastKnownVersions.tlc != "")
                        {
                            // bu itemi listeden sil...
                            ListOccSelfVersionsCalulated.push(this.OCCSelfVersions_VS_IPADLastKnownVersions[i])
                        }
                }

                return ListOccSelfVersionsCalulated

            },



            getDatevalue : {
                 get()
                 {
                     return this.flight.std.toString().substring(0,10);
                 },
                 set()
                 {

                 }
            },


        },
    }
</script>

<style scoped>

    .VersHead{
        text-align: center !important;
    }

    .LeftBorderLine{
        border-left: 1px solid gray;
    }

    .RightBorderLine{
        border-right: 1px solid gray;
    }

    .RowVersionDiff {
        background-color: white;
    }

    .RowVersionSame {
        background-color: orange;
    }

    .RowinP{
        width: 75px;
        word-wrap: break-word;
    }

    .title {
        padding: 10px;
        background-color: #b5b5b53d;
    }

    .input {
        width: 300px;
    }

    .label {
        width: 100px;
        background-color: white;
        height: 35px;
        padding: 5px;
    }

    .save-button {
        transition: all .3s ease-in-out;
        margin-left: -200px;
    }

    .input {
        width: 270px;
    }

    .Versions{

    }

</style>
